import * as React from 'react';
import { H2 } from '@grandvisionhq/iris-ui';
import { ProductStockIndicator } from '../../StockIndicator/ProductStockIndicator.js';

// There are 2 implementations here for rendering a stock indicator. For multivariancy, enableStockIndicator is
// used to determine whether a stock indicator is shown, and if it is, the ProductStockIndicator component is shown.
// For omnivariancy, a React component, VariantTreeStockIndicator, is passed through the rightSlot prop from the omnivariancy configuration.
const FacetPickerHeader = ({ children , enableStockIndicator =false , rightSlot ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "facet-picker-header"
    }, /*#__PURE__*/ React.createElement(H2, {
        className: "facet-picker-header__text",
        variant: "heading-smallest"
    }, children), enableStockIndicator && /*#__PURE__*/ React.createElement(ProductStockIndicator, null), rightSlot);
};

export { FacetPickerHeader };
//# sourceMappingURL=FacetPickerHeader.js.map
